import React, { createContext, useState, useEffect, useContext } from 'react'
import { getDemographicSurveysBySession } from '../../workspace/service/demographicSurveyService'
import { getPostSurveysBySession } from '../../workspace/service/postSurveyService'

export const SurveyDataContext = createContext()

export const SurveyDataProvider = ({ sessionId, children }) => {
  const [demographics, setDemographics] = useState([])
  const [postSurveys, setPostSurveys] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!sessionId) return
    setLoading(true)
    setError(null)

    Promise.all([
      getDemographicSurveysBySession(sessionId).catch(() => []),
      getPostSurveysBySession(sessionId).catch(() => []),
    ])
      .then(([demo, post]) => {
        setDemographics(demo || [])
        setPostSurveys(post || [])
      })
      .catch(e => setError(e.message))
      .finally(() => setLoading(false))
  }, [sessionId])

  return (
    <SurveyDataContext.Provider value={{
      demographics,
      postSurveys,
      loading,
      error,
      demographicCount: demographics.length,
      postSurveyCount: postSurveys.length,
    }}>
      {children}
    </SurveyDataContext.Provider>
  )
}

export const useSurveyData = () => useContext(SurveyDataContext)